(function () {
	const slideshow = () => {
		$(".product-markers-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const markers = $(this).find(".product-markers__marker");
			const id = $(this).attr("id");
			const box = $(this).find(".product-markers");
			const swiperEl = $(this).find(".swiper").get(0);
			const paginationEl = $(this).find(".swiper-pagination").get(0);
			if (paginationEl) {
				paginationEl.innerHTML = "";
				paginationEl.classList.remove("swiper-pagination-bullets-dynamic");
			}
			if (swiperEl && swiperEl.swiper) {
				swiperEl.swiper.destroy(true, true);
			}
			let swiperParms = {
				effect: box.data("effect"),
				speed: box.data("speed") * 1000,
				creativeEffect: {
					prev: {
						shadow: false,
						translate: [0, 0, -400],
					},
					next: {
						translate: ["100%", 0, 0],
					},
				},
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: false,
				},
				flipEffect: {
					slideShadows : false,
				},
				loop: false,
				autoHeight: false,
				calculateHeight: false,
				watchOverflow: true,
				keyboard: true,
				allowTouchMove: true,
				simulateTouch: true,
				grabCursor: true,
				touchEventsTarget: "container",
				followFinger: true,
				shortSwipes: true,
				longSwipes: true,
				longSwipesRatio: 0.15,
				touchRatio: 1.2,
				threshold: 2,
				touchStartPreventDefault: true,
				touchStartForcePreventDefault: true,
				preventClicks: true,
				preventClicksPropagation: true,
				navigation: false,
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: false,
					thresholdDelta: 8,
					thresholdTime: 120,
					sensitivity: 1,
				},
			};
			if (paginationEl) {
				swiperParms.pagination = {
					el: paginationEl,
					clickable: true,
					dynamicBullets: false,
				};
			}
			const swiper = new Swiper(swiperEl, swiperParms);
			markers.each(function () {
				$(this).click(function () {
					const index = $(this).data("slide-index");
					markers.removeClass("active");
					$(this).addClass("active");
					swiper.slideTo(index, 1000);
				});
			});
			swiper.on("slideChange", function () {
				const reallIndex = swiper.realIndex;
				markers.removeClass("active");
				$(`[data-slide-index="${reallIndex}"]`).addClass("active");
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();
